module.exports = __webpack_public_path__ + "img/vpc_d.9a4e050.svg";